import MuiSnackbar, { type SnackbarProps } from "@mui/material/Snackbar";

type Props = Pick<
  SnackbarProps,
  | "open"
  | "message"
  | "autoHideDuration"
  | "onClose"
  | "children"
  | "anchorOrigin"
>;

export const Snackbar = (props: Props) => (
  <MuiSnackbar
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
    {...props}
  />
);
